import "core-js/modules/es.array.push.js";
import { showConfirmDialog } from 'vant';
import ListViewCpt from '@/components/list/ListViewCpt';
import PopupPickerCpt from '@/components/data-picker/PopupPickerCpt';
import { rqtPostAttachmentList, rqtPostAttachmentFileUpload, rqtPostAttachmentBatchDelete } from '@/services/common/attachment';
import { rqtPostAttachmentTypeList } from '@/services/common/attachment-type';
import { isImgUrl, isVideoUrl, isAudioUrl, getUnrelatedAttachments, delUnrelatedAttachments, setUnrelatedAttachments, delUnrelatedAttachment } from '@/utils/public/file';
export default {
  name: 'AttachmentListCpt',
  components: {
    ListViewCpt,
    PopupPickerCpt
  },
  props: {
    businessId: {
      type: [Number, String]
    },
    attachmentType: {
      type: String,
      required: true
    },
    flag: {
      type: [String],
      default: 'r'
    }
  },
  data() {
    return {
      searchForm: {
        businessId: this.businessId,
        attachmentType: this.attachmentType
      },
      listRequest: rqtPostAttachmentList,
      //{name: '请选择'}
      attachmentSubTypes: [],
      attachmentSubTypeName: null,
      attachmentSubType: null,
      subTypeFieldNames: {
        text: 'name',
        value: 'type'
      },
      remark: null,
      showPreview: false,
      images: [],
      audioUrl: null,
      videoUrl: null,
      newAttachments: [],
      //用于上一个页面未保存导致没有businessId，但是先保存了附件的情形。
      isImgUrl,
      isVideoUrl,
      isAudioUrl
    };
  },
  computed: {
    readonly() {
      return this.flag == 'w' ? false : true;
    },
    rightIcon() {
      if (this.attachmentSubTypeName && this.attachmentSubTypeName.length > 0) {
        return 'close';
      } else {
        return '';
      }
    }
  },
  async mounted() {
    try {
      let res = await rqtPostAttachmentTypeList({
        type: this.attachmentType
      });
      res = res.data.data.find(e => !e.parentId);
      res = await rqtPostAttachmentTypeList({
        parentId: res.id
      });
      this.attachmentSubTypes = res.data.data;
    } catch (e) {
      console.error(e);
      this.attachmentSubTypes = [];
    }
    if (!this.businessId) {
      this.newAttachments = getUnrelatedAttachments(this.attachmentType);
    } else {
      delUnrelatedAttachments();
    }
  },
  methods: {
    onListDataChange() {},
    formatSubType(subType) {
      for (let item of this.attachmentSubTypes) {
        if (subType == item.type) {
          return item.name;
        }
      }
    },
    onPopupSubTypeClick() {
      this.$refs.PopupPickerCpt.showView();
    },
    onPopupPickerSelect(selectedValues, selectedOptions) {
      this.attachmentSubType = selectedValues[0];
      this.attachmentSubTypeName = selectedOptions[0].name;
    },
    onSubTypeCloseClick() {
      this.attachmentSubType = null;
      this.attachmentSubTypeName = null;
    },
    beforeRead(files) {
      let that = this;
      const format = /(^(image|video|audio)\/)|(^application\/.*(document|ms-excel|sheet|pdf|x-zip-compressed)$)/;
      //因为开启了多选，所以当选择一张图片时， file 为一个对象，多张时，file 为数组，所以需要判断
      if (Array.isArray(files)) {
        for (let i = 0; i < files.length; i++) {
          if (!format.test(files[i].type)) {
            that.$message.error('不支持的文件格式');
            return false;
          }
        }
      } else {
        if (!format.test(files.type)) {
          that.$message.error('不支持的文件格式');
          return false;
        }
      }
      return true;
    },
    //上传后的回调
    afterRead(files) {
      const formData = new FormData();
      if (Array.isArray(files)) {
        files.forEach(file => {
          formData.append('files', file.file);
        });
      } else {
        formData.append('files', files.file);
      }
      const param = {
        businessId: this.businessId,
        attachmentType: this.attachmentType,
        attachmentSubType: this.attachmentSubType,
        remark: this.remark
      };
      formData.append('param', JSON.stringify(param));
      rqtPostAttachmentFileUpload(formData).then(res => {
        if (this.businessId) {
          this.$refs.ListViewCpt.initListData();
        } else {
          this.newAttachments.push(...res.data.data.successFiles);
          setUnrelatedAttachments(this.newAttachments);
        }
      }).finally(() => {
        this.onSubTypeCloseClick();
        this.remark = null;
      });
    },
    playItem(item, e) {
      if (this.isSpecialUrl(item.previewUrl)) {
        e.preventDefault();
        this.showPreview = true;
        this.images = [item.previewUrl];
      }
      /*
      if(isImgUrl(item.uploadFileName)) {
        e.preventDefault()
        ImagePreview([item.previewUrl])
      } else if (isVideoUrl(item.uploadFileName)) {
        e.preventDefault()
        this.showVideo = true
        this.videoUrl = item.previewUrl
      } else if (isAudioUrl(item.uploadFileName)) {
        e.preventDefault()
        this.showAudio = true
        this.audioUrl = item.previewUrl
      } 
      else {
        rqtPostAttachmentDownload(item)
        .then((res) => {
          this.$message.success("准备下载");
          dmFileByAxios(res);
        })
        .catch();
      }
      */
    },

    deleteItem(item, index) {
      showConfirmDialog({
        title: '提醒',
        message: "确定删除？"
      }).then(() => {
        rqtPostAttachmentBatchDelete([item]).then(() => {
          this.$message.success("删除成功");
          if (this.businessId) {
            this.$refs.ListViewCpt.remove(index);
          } else {
            this.newAttachments.splice(index, 1);
            delUnrelatedAttachment(item.businessType, index);
          }
        });
      }).catch(() => {
        return;
      });
    },
    isSpecialUrl(url) {
      if (isImgUrl(url) || isVideoUrl(url) || isAudioUrl(url)) {
        return true;
      } else {
        return false;
      }
    }
  }
};